<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2024-02-05</p>
    <div class="content">
      <!-- 第一段内容：星环聚能磁体成功研制 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[0] || ''"></p>
        </div>
      </div>

      <!-- 图片1位置（如果有的话） -->
      <div class="content-section image-section" v-if="currentNews.other?.picture1?.url">
        <div class="image-container">
          <img :src="currentNews.other.picture1.url">
          <p class="image-caption" v-if="currentNews.other.picture1.caption">{{ currentNews.other.picture1.caption }}</p>
        </div>
      </div>

      <!-- 第二段内容：上海超导合作情况 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[1] || ''"></p>
        </div>
      </div>

      <!-- 相关链接 -->
      <div class="content-section" v-if="currentNews.other?.links">
        <div class="text-block">
          <h3>相关链接：</h3>
          <div v-html="currentNews.other.links"></div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'xinghuan18t');
  return newsItem || {};
});

</script>

<style scoped>
.page-container {
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}

.page-title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;
}

.content {
  margin-top: 2rem;
}

.content-section {
  margin-bottom: 2rem;
}

.text-block p {
  font-size: 1.1rem;
  text-align: justify;
  margin-bottom: 1rem;
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  max-width: 100%;
}

.image-container img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.image-caption {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #666;
  font-style: italic;
}

h3 {
  color: #333;
  margin-bottom: 1rem;
}

:deep(a) {
  color: #007bff;
  text-decoration: none;
}

:deep(a:hover) {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .page-container {
    padding: 1rem;
  }
  
  .page-title {
    font-size: 1.5rem;
  }
  
  .text-block p {
    font-size: 1rem;
  }
}
</style> 